import React from 'react';
import { Helmet } from "react-helmet";

import Hero from '../components/Hero';
import Products from '../components/Products';
import Quality from '../components/Quality';
import Contact from '../components/Contact';
import About from '../components/About';

function Home() {
  return (
    <>
      <Helmet>
        <title>
          Leocord | Trusted Pharmaceutical and Healthcare
        </title>

        <meta
          name="description"
          content="Leocord is a trusted pharmaceutical supplier providing high-quality medicines and healthcare products to hospitals, clinics, and healthcare institutions."
        />

        <meta
          name="keywords"
          content="pharmaceutical supplier, hospital medicine supplier, pharmaceutical distributor India, healthcare pharma supplier"
        />

        <link rel="canonical" href="https://leocordhealthcare.com/" />

        {/* Open Graph for Social Sharing */}
        <meta property="og:title" content="Leocord Pharmaceutical Supplier" />
        <meta
          property="og:description"
          content="Trusted pharmaceutical supplier delivering healthcare medicines to hospitals and clinics."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://leocordhealthcare.com/" />
      </Helmet>
      <Hero />
      <About />
      <Products />
      <Quality />
      <Contact />
    </>
  );
}

export default Home;